export const supplierreportdata = [
  {
    id: '1',
    img: 'assets/img/products/stock-img-01.png',
    purchaseDate: '19 Jan 2023',
    product: 'Lenovo 3rd Generation',
    purchaseAmount: '$1500',
    purchaseQty: '50',
    paid: '$1500',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 2,
    img: 'assets/img/products/stock-img-06.png',
    purchaseDate: '24 Jan 2023',
    product: 'Bold V3.2',
    purchaseAmount: '$1200',
    purchaseQty: '20',
    paid: '$1200',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 3,
    img: 'assets/img/products/stock-img-02.png',
    purchaseDate: '03 Feb 2023',
    product: 'Nike Jordan',
    purchaseAmount: '$2000',
    purchaseQty: '30',
    paid: '$2000',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 4,
    img: 'assets/img/products/stock-img-03.png',
    purchaseDate: '15 Feb 2023',
    product: 'Apple Series 5 Watch',
    purchaseAmount: '$800',
    purchaseQty: '80',
    paid: '$800',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 5,
    img: 'assets/img/products/stock-img-04.png',
    purchaseDate: '12 Mar 2023',
    product: 'Amazon Echo Dot',
    purchaseAmount: '$500',
    purchaseQty: '70',
    paid: '$500',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 6,
    img: 'assets/img/products/stock-img-05.png',
    purchaseDate: '25 Mar 2023',
    product: 'Lobar Handy',
    purchaseAmount: '$400',
    purchaseQty: '100',
    paid: '$400',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 7,
    img: 'assets/img/products/expire-product-01.png',
    purchaseDate: '02 Apr 2023',
    product: 'Red Premium Handy',
    purchaseAmount: '$300',
    purchaseQty: '120',
    paid: '$300',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 8,
    img: 'assets/img/products/expire-product-02.png',
    purchaseDate: '19 Apr 2023',
    product: 'Iphone 14 Pro',
    purchaseAmount: '$1800',
    purchaseQty: '40',
    paid: '$1800',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 9,
    img: 'assets/img/products/expire-product-03.png',
    purchaseDate: '11 May 2023',
    product: 'Black Slim 200',
    purchaseAmount: '$700',
    purchaseQty: '300',
    paid: '$700',
    balance: '$0.00',
    status: 'Received',
  },
  {
    id: 10,
    img: 'assets/img/products/expire-product-04.png',
    purchaseDate: '27 May 2023',
    product: 'Woodcraft Sandal',
    purchaseAmount: '$600',
    purchaseQty: '200',
    paid: '$600',
    balance: '$0.00',
    status: 'Received',
  },
];

export const returnsupplierdata = [
  {
    id: 1,
    reference: 'PR0001',
    supplierName: 'Apex Computers',
    amount: '$1800',
    paid: '$1800',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
  {
    id: 2,
    reference: 'PR0002',
    supplierName: 'Beats Headphones',
    amount: '$1200',
    paid: '$0.00',
    dueAmount: '$1200',
    status: 'Completed',
    paymentStatus: 'Unpaid',
  },
  {
    id: 3,
    reference: 'PR0003',
    supplierName: 'Dazzle Shoes',
    amount: '$2000',
    paid: '$2000',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
  {
    id: 4,
    reference: 'PR0004',
    supplierName: 'Best Accessories',
    amount: '$1300',
    paid: '$1300',
    dueAmount: '$1300',
    status: 'Completed',
    paymentStatus: 'Overdue',
  },
  {
    id: 5,
    reference: 'PR0005',
    supplierName: 'Aesthetic Bags',
    amount: '$400',
    paid: '$0.00',
    dueAmount: '$400',
    status: 'Completed',
    paymentStatus: 'Unpaid',
  },
  {
    id: 6,
    reference: 'PR0006',
    supplierName: 'Hatimi Hardwares',
    amount: '$700',
    paid: '$700',
    dueAmount: '$700',
    status: 'Completed',
    paymentStatus: 'Overdue',
  },
  {
    id: 7,
    reference: 'PR0007',
    supplierName: 'Shine Bags',
    amount: '$800',
    paid: '$800',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
  {
    id: 8,
    reference: 'PR0008',
    supplierName: 'Alpha Mobiles',
    amount: '$300',
    paid: '$300',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
  {
    id: 9,
    reference: 'PR0009',
    supplierName: 'Sigma Chairs',
    amount: '$120',
    paid: '$120',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
  {
    id: 10,
    reference: 'PR0010',
    supplierName: 'Zenith Bags',
    amount: '$600',
    paid: '$600',
    dueAmount: '$0.00',
    status: 'Completed',
    paymentStatus: 'Paid',
  },
];

export const paymentdata = [
  {
    id: 1,
    Date: '19 Jan 2023',
    Purchase: 'PR_0001',
    Reference: 'INV/PR_0001',
    SupplierName: 'Apex Computers',
    Amount: '$1800',
    Paid: '$1800',
    PaidBy: 'Cash',
  },
  {
    id: 2,
    Date: '24 Jan 2023',
    Purchase: 'PR_0002',
    Reference: 'INV/PR_0002',
    SupplierName: 'Beats Headphones',
    Amount: '$1100',
    Paid: '$1100',
    PaidBy: 'Cash',
  },
  {
    id: 3,
    Date: '02 Feb 2023',
    Purchase: 'PR_0003',
    Reference: 'INV/PR_0003',
    SupplierName: 'Dazzle Shoes',
    Amount: '$2000',
    Paid: '$2000',
    PaidBy: 'Cash',
  },
  {
    id: 4,
    Date: '15 Feb 2023',
    Purchase: 'PR_0004',
    Reference: 'INV/PR_0004',
    SupplierName: 'Best Accessories',
    Amount: '$700',
    Paid: '$700',
    PaidBy: 'Cash',
  },
  {
    id: 5,
    Date: '12 Mar 2023',
    Purchase: 'PR_0005',
    Reference: 'INV/PR_0005',
    SupplierName: 'Aesthetic Bags',
    Amount: '$500',
    Paid: '$500',
    PaidBy: 'Cash',
  },
  {
    id: 6,
    Date: '26 Mar 2023',
    Purchase: 'PR_0006',
    Reference: 'INV/PR_0006',
    SupplierName: 'Hatimi Hardwares',
    Amount: '$1600',
    Paid: '$1600',
    PaidBy: 'Cash',
  },
  {
    id: 7,
    Date: '16 Apr 2023',
    Purchase: 'PR_0007',
    Reference: 'INV/PR_0007',
    SupplierName: 'Shine Bags',
    Amount: '$600',
    Paid: '$600',
    PaidBy: 'Cash',
  },
  {
    id: 8,
    Date: '24 Apr 2023',
    Purchase: 'PR_0008',
    Reference: 'INV/PR_0008',
    SupplierName: 'Alpha Mobiles',
    Amount: '$120',
    Paid: '$120',
    PaidBy: 'Cash',
  },
  {
    id: 9,
    Date: '13 May 2023',
    Purchase: 'PR_0009',
    Reference: 'INV/PR_0009',
    SupplierName: 'Sigma Chairs',
    Amount: '$300',
    Paid: '$300',
    PaidBy: 'Cash',
  },
  {
    id: 10,
    Date: '29 May 2023',
    Purchase: 'PR_0010',
    Reference: 'INV/PR_0011',
    SupplierName: 'Zenith Bags',
    Amount: '$350',
    Paid: '$350',
    PaidBy: 'Cash',
  },
];
